import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../components/pages/home/Index.vue";
import Search from "../components/pages/Search.vue";
import About from "../components/pages/about/Index.vue";
import Team from "../components/pages/Team.vue";
import GalleriesList from "../components/pages/galleries/List.vue";
import GalleriesItem from "../components/pages/galleries/Item.vue";
import ArticlesList from "../components/pages/articles/List.vue";
import ArticlesItem from "../components/pages/articles/Item.vue";
import VideosList from "../components/pages/videos/List.vue";
import VideosItem from "../components/pages/videos/Item.vue";
import PressContact from "../components/pages/PressContact.vue";
import MedicalBulletin from "../components/pages/MedicalBulletin.vue";
import Social from "../components/pages/Social.vue";
import ProjectsTopics from "../components/pages/projects/Topics.vue";
import ProjectsCulturalSpace from "../components/pages/projects/CulturalSpace.vue";
import ProjectsNewBorns from "../components/pages/projects/NewBorns.vue";
import Contact from "../components/pages/Contact.vue";
import WorkWithUs from "../components/pages/WorkWithUs.vue";
import FormSuccess from "../components/pages/fallback/FormSuccess.vue";
import Services from "../components/pages/Services.vue";
import RegistersPregnant from "../components/pages/RegistersPregnant.vue";
import BreastfeedingJourney from "../components/pages/BreastfeedingJourney.vue";
import PolicyPrivacy from "../components/pages/PolicyPrivacy.vue";
import Error404 from "../components/pages/fallback/Error404.vue";
import Uti from "../components/pages/specialties/Uti.vue";
import Care from "../components/pages/specialties/Care.vue";
import Vaccine from "../components/pages/specialties/Vaccine.vue";
import Image from "../components/pages/specialties/Image.vue";
import ProjectsAngels from "../components/pages/projects/Angels.vue";
import FilesDownload from "../components/pages/FilesDownload.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/arquivos/download",
    name: "Download de Arquivos",
    component: FilesDownload,
  },
  {
    path: "/busca",
    name: "Busca",
    component: Search,
  },
  {
    path: "/sobre-nos",
    name: "Sobre Nós",
    component: About,
  },
  {
    path: "/equipe/:item",
    name: "Conheça Nossos Especialistas",
    component: Team,
  },
  {
    path: "/imprensa/galerias-de-fotos",
    name: "Galerias de Fotos",
    component: GalleriesList,
  },
  {
    path: "/imprensa/galerias-de-fotos/:item",
    name: "Galeria de Fotos",
    component: GalleriesItem,
  },
  {
    path: "/imprensa/noticias",
    name: "Notícias",
    component: ArticlesList,
  },
  {
    path: "/imprensa/noticias/:item",
    name: "Notícia",
    component: ArticlesItem,
  },
  {
    path: "/imprensa/videos",
    name: "Videos",
    component: VideosList,
  },
  {
    path: "/imprensa/videos/:item",
    name: "Vídeo",
    component: VideosItem,
  },
  {
    path: "/imprensa/boletim-medico",
    name: "Boletim Médico",
    component: MedicalBulletin,
  },
  {
    path: "/imprensa/contato-para-imprensa",
    name: "Contato para Imprensa",
    component: PressContact,
  },
  {
    path: "/social/:item",
    name: "Social",
    component: Social,
  },
  {
    path: "/projetos/espaco-cultural",
    name: "Espaço Cultural",
    component: ProjectsCulturalSpace,
  },
  {
    path: "/projetos/nasci-no-h2p",
    name: "Nasci no H2P",
    component: ProjectsNewBorns,
  },
  {
    path: "/projetos/:item",
    name: "Projetos",
    component: ProjectsTopics,
  },
  {
    path: "/atendimento",
    name: "Atendimento",
    component: Contact,
  },
  {
    path: "/atendimento/obrigado",
    name: "Obrigado!",
    meta: {
      text: "Agradecemos seu contato, responderemos em breve.",
      to: "/atendimento",
    },
    component: FormSuccess,
  },
  {
    path: "/trabalhe-conosco",
    name: "Trabalhe Conosco",
    component: WorkWithUs,
  },
  {
    path: "/trabalhe-conosco/obrigado",
    name: "Obrigado!",
    meta: {
      text: "Agradecemos seu contato, responderemos em breve.",
      to: "/trabalhe-conosco",
    },
    component: FormSuccess,
  },
  {
    path: "/servicos/:item",
    name: "Serviços",
    component: Services,
  },
  {
    path: "/curso-de-gestantes",
    name: "Curso de Gestantes",
    component: RegistersPregnant,
  },
  {
    path: "/jornadadealeitamento",
    name: "Jornada de Aleitamento",
    component: BreastfeedingJourney,
  },
  {
    path: "/politica-de-privacidade",
    name: "Política de Privacidade",
    component: PolicyPrivacy,
  },
  {
    path: "/uti",
    name: "UTI",
    component: Uti,
  },
  {
    path: "/home-care",
    name: "Home Care",
    component: Care,
  },
  {
    path: "/clinica-de-imagem",
    name: "Clínica de Imagem",
    component: Image,
  },
  {
    path: "/vacinas",
    name: "Vacinas",
    component: Vaccine,
  },
  {
    path: "/iniciativa-angels",
    name: "Projeto Angels",
    component: ProjectsAngels,
  },
  {
    name: "Erro 404",
    path: "/erro404",
    component: Error404,
  },
  {
    path: "*",
    beforeEnter: (to, from, next) => {
      next("/erro404");
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: "smooth",
      };
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes,
});

export default router;
